export const environment = {
  production: false,
  api: 'https://anypointdev.pars.com.br/api',
};
